import { Alert, Stack } from '@srichaitra/ui';
import { labels } from '@srichaitra/constants';
import { dismissNotification, selectNotifications, useAppDispatch, useAppSelector } from '@srichaitra/store';

/**
 * Renders the notification queue.
 *
 * Mounted once, in the shell, so any slice or screen can report an outcome by
 * dispatching an action rather than owning a banner of its own. Renders nothing
 * when the queue is empty — an always-present empty container would still be an
 * ARIA live region, and live regions that appear and vanish get announced as
 * changes.
 */
export function NotificationCenter() {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector(selectNotifications);

  if (notifications.length === 0) return null;

  return (
    <Stack gap={2}>
      {notifications.map((item) => (
        <Alert
          key={item.id}
          tone={item.tone}
          title={item.title}
          onDismiss={() => dispatch(dismissNotification(item.id))}
          dismissLabel={labels.actions.dismiss}
        >
          {item.message}
        </Alert>
      ))}
    </Stack>
  );
}
